<template>
  <div class="base-box">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div style="text-align:center; padding:30px 0;position: fixed;top: 1.5rem;z-index: 999;">
      <van-overlay :show="loading" :lock-scroll="true" style="z-index: 888;">
        <van-loading color="#fff" size="24px" vertical style="z-index: 999;margin-top: 50%;">正在提交中...</van-loading>
      </van-overlay>
    </div>
    <p>标注<span style="color: red"> “ * ” </span>的填写项为必填项,如空缺则不能完成注册。</p>
    <div class="fontBox">

      <advanced-form v-if="member.id" ref="advForm" :initFields="fields" :formData.sync="member"
        :allDictionary="allDictionary" :allAddress="cityList" :branchsList="branchsList"
        :customDataList="customDataList" @getFields="getFields" :isDisabled="disabled"></advanced-form>
    </div>
    <sealInformation ref="childMethod" v-if="member.id" :member.sync="member" @changeData="handleChangeData">
    </sealInformation>
    <div class="buttonBox" v-if="member.memberStatus != 3&&member.memberStatus != 13&&portraitId">
      <div v-if="member.memberStatus !=13">
        <van-button :disabled="disabled" type="primary" plain @click="printing"
          style="margin-left: 0.2rem;">下载会员申请表</van-button>
        <van-button :disabled="disabled" type="primary" plain @click="dialogSeal"
          style="margin-left: 0.2rem;">上传会员申请表</van-button>
      </div>
    </div>
    <div class="buttonBox" v-if="member.memberStatus != 3&&member.memberStatus != 13">
      <template v-if="
      member.memberStatus == null ||
      member.memberStatus == 15 ||
      member.memberStatus == 16 ||
      member.memberStatus == 14 ||
      member.memberStatus == 4    ">
        <van-button type="primary" size="large" plain @click="saveZc(true)">保存</van-button>
        <van-button type="primary" v-if="member.seal" size="large" @click="save()">提交入会申请</van-button>
      </template>
      <template v-else class="form-btn">
        <van-button v-if="disabled" plain @click="disabled=false">修改信息</van-button>
        <van-button v-else type="primary" plain @click="save()">提交修改</van-button>
      </template>
    </div>
    <div class="buttonBox" v-if="disabled"></div>

  </div>
</template>
<script>
  import memberPostTable from "../../components/memberPostTable";
  import researchProjects from "../../views/register/grmember/researchProjects.vue";
  import AdvancedForm from "../../components/AdvancedForm.vue";
  import vHead from "../../components/Subhead.vue";
  import sealInformation from "./sealInformation"
  import {
    findFileById,
    getBranchs,
    getSingleRegisterSetting,
    saveMembers,
    getNationality,
    getDuesList,
    printSingleSeal,
    getUser,
    getAuditInfo
  } from "@/api/dictionary";
  import {
    registerMemberEdit,
  } from "@/api/login";
  import { addTokenToUrl } from "@/utils/auth";
  import {
    Field,
    NavBar,
    Button,
    Toast,
    Tab,
    Tabs,
    Dialog,
    Overlay, Loading
  } from "vant";
  import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    inject: ["reload"],
    data() {
      return {
        printingInfo: printSingleSeal,
        //   fileList: [],
        //   fileList2: [],
        loading: false,
        active: 0,
        title: "入会申请表",
        //   porName:"",
        //   jgName: "",
        //   addName: "",
        show: false,
        // areaList,
        allAddress: [],
        items: [],
        addrItems: [],
        titleId: null,
        cityId: null,
        activeId: null,
        activeIndex: null,
        infos: {},
        changeData: {},

        params: {
          memberType: null,
          name: "",
          code: "",
          gender: null,
          birthday: new Date(),
          partisan: "",
          workNature: "",
          title: "",
          education: "",
          degree: "",
          idType: "",
          nationality: "",
          recommendUnitId: "",
          concernUnitId: "",
          nativeProvince: "",
          nativeCity: "",
          province: "",
          city: "",
          titleFileId: "",
          portraitId: "",
          school: "",
          major: "",
          company: "",
          socialTenure: "",
          idNumber: "",
          workMajor: "",
          jobPerformance: "",
          fullAddress: "",
          zipcode: "",
          email: "",
          mobile: "",
          telephone: "",
          experience: "",
          achievement: "",
          awards: "",
        },
        branchList: [],
        customDataList: {},
        member: {},
        fields: [],
        disabled: false,
        portraitId: "",
      };
    },
    components: {
      vHead,
      memberPostTable,
      AdvancedForm,
      researchProjects,
      sealInformation,
      [Field.name]: Field,
      [Button.name]: Button,
      [Toast.name]: Toast,
      [NavBar.name]: NavBar,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Dialog.name]: Dialog,
      [Loading.name]: Loading,
      [Overlay.name]: Overlay,
    },
    computed: {
      ...mapState([
        "memberTypeList",
        "zhichengList",
        "cityList",
        "titleList",
        "addrList",
        "branchsList",
      ]),
      ...mapGetters([
        "allDictionary",
        "GENDER",
        "POLITICAL_STATUS",
        "EDUCATION",
        "DEGREE",
        "WORK_NATURE",
        "ID_TYPE",
        "NATIONALITY",
      ]),
      titleFileId() {
        return this.$route.query && this.$route.query.titleFileId;
      },
      //会员类型名称
      memberName() {
        let id = this.params.memberType;

        if (!id) {
          return "内容";
        } else {
          let obj = this.memberTypeList.find((item) => item.memberType === id);
          return obj.dueName;
        }
      },
      gender() {
        let id = this.params.gender;
        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = this.GENDER.find((item) => item.value === id);
          if (obj) return obj.name;
        }
      },
      sheng() {
        return this.cityList.filter((item) => {
          return item.level === 1;
        });
      },
      shi: function () {
        return this.cityList.filter((item) => {
          return item.parentId === this.sheng[0].id;
        });
      },
      titleName() {
        return this.$route.query && this.$route.query.titleName;
      },
      portraitName() {
        return this.$route.query && this.$route.query.portraitName;
      },
    },
    methods: {
      ...mapActions([
        "getDictionaryList",
        "getMemberTypeList",
        "getBranchsList",
        "getZhiChengList",
        "getCityList",
      ]),
      ...mapMutations(["setMemberInfo"]),
      handleChangeData(newData) {
        this.member.seal = newData
      },

      onClickLeft() {
        if (!this.member.memberNo && !this.member.memberStatus) {
          Dialog.alert({
            title: '提示',
            message: '请您填写并提交入会申请表！',
          }).then(() => {
            // on close
          });
          return;
        }
        this.$router.push({ name: "MemberCenter" });
      },
      printing() {
        let params = this.member
        let valid = this.$refs["advForm"].validateForm()
        if (!valid) {
          return
        }
        if (params.birthday) {
          params.birthday = params.birthday.substr(0, 10)
        }
        if (params.expiryDate && params.expiryDate.length == 10) {
          params.expiryDate =
            params.expiryDate + " " + "00" + ":" + "00" + ":" + "00"
        }
        saveMembers(params).then((res) => {
          if (res.success) {
            let system = navigator.userAgent
            let isAndroid =
              system.indexOf("Android") > -1 || system.indexOf("Adr") > -1 // android终端
            let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
            let url = this.printingInfo + "?memberId=" + this.member.id
            // 使用
            if (isAndroid) {
              //android终端
              console.log("我是安卓")
              this.openWindowWithToken(url)
            } else if (isiOS) {
              //ios终端
              console.log("我是ios")
              window.location.href = addTokenToUrl(url)
            }
          } else {
            Toast.fail("保存失败")
          }
        })
      },
      dialogSeal() {
        this.saveZc(false)
        this.$refs.childMethod.showZl()
      },
      save() {
        let params = this.member;
        if (params.id.length === 0) {
          return;
        }
        if (!params.seal && !params.memberNo) {
          Toast.fail('请上传会员申请表')
          return
        }
        let valid = this.$refs["advForm"].validateForm();
        if (!valid) {
          return;
        }
        if (!this.$regexp.mobile(params.mobile)) {
          Toast.fail("请输入正确的手机号码");
          return;
        }
        if (!this.$regexp.email(params.email)) {
          Toast.fail("请输入正确的电子信箱");
          return;
        }

        if (params.birthday) {
          params.birthday = params.birthday.substr(0, 10);
        }
        if (params.expiryDate && params.expiryDate.length == 10) {
          params.expiryDate = params.expiryDate + ' ' + '00' + ":" + '00' + ":" + '00';
        }
        params.flag = 0;
        params.login = params.mobile
        this.loading = true
        registerMemberEdit(params).then((res) => {
          if (res.success) {
            this.loading = false
            this.$router.push({ name: "MemberCenter" });
          } else {
            this.loading = false
            Toast.fail("保存失败");
          }
        });
      },
      saveZc(status) {
        let params = this.member;
        if (params.birthday) {
          params.birthday = params.birthday.substr(0, 10);
        }
        if (params.expiryDate && params.expiryDate.length == 10) {
          params.expiryDate = params.expiryDate + ' ' + '00' + ":" + '00' + ":" + '00';
        }

        saveMembers(params).then((res) => {
          if (res.success) {
            if (status) {
              Toast.success("保存成功");
              this.reload()
            }
            // this.$router.push({ name: 'MemberCenter'});
          } else {
            Toast.fail("保存失败");
          }
        });
      },
      getFields(val) {
        var params = {};
        if (val) {
          if (val == 1) {//普通会员1
            params.batchType = 5;
            params.businessType = 2;
          } else if (val == 2) {//高级会员2
            params.batchType = 5;
            params.businessType = 16;
          } else if (val == 3) {//学生会员3
            params.batchType = 5;
            params.businessType = 15;
          } else {//会议注册网员9
            params.batchType = 5;
            params.businessType = 2;
          }
        } else {
          if (this.member.memberType == 1) {//普通会员1
            params.batchType = 5;
            params.businessType = 2;
          } else if (this.member.memberType == 2) {//高级会员2
            params.batchType = 5;
            params.businessType = 16;
          } else if (this.member.memberType == 3) {//学生会员3
            params.batchType = 5;
            params.businessType = 15;
          } else {//会议注册网员9
            params.batchType = 5;
            params.businessType = 2;
          }
        }
        getSingleRegisterSetting(params).then((resp) => {
          if (resp.success) {
            this.fields = resp.result;
          } else {
            Toast.fail(resp.message);
          }
        });
      },
      getUserInfo() {
        return new Promise((resolve) => {
          getUser().then(res => {
            if (res.success) {
              this.member = res.result;
              if (this.member.expiryDate) {
                this.member.expiryDate = this.member.expiryDate.substr(0, 10);
              }
              this.portraitId = this.member.portraitId
              if (this.member.memberStatus == 4 || this.member.memberStatus == 15 || this.member.memberStatus == 14 || this.member.memberStatus == 16) {
                this.getAuditInfoList();
              }
              resolve(res.result);
            }
          })
        })

      },
      getAuditInfoList() {
        let params = {
          memberId: this.member.id,
          memberCategory: 1
        };

        getAuditInfo(params).then(res => {
          if (res.success) {
            Dialog.alert({
              title: '当前审核没有通过，请按提示修改重新提交！',
              message: res.result.reason,
            })
              .then(() => {

              })
              .catch(() => { });
          }
        });
      }
    },

    async mounted() {
      await this.getUserInfo()
      this.getFields();
      getNationality({}).then(res => {
        if (res.success) {
          res.result.forEach(itm => {
            itm.value = itm.value;
            itm.name = itm.label;
          });
          this.customDataList["country"] = res.result;
          this.$nextTick(() => {
            this.$refs.advForm.$forceUpdate()
          })
        } else {
          Toast.fail(res.message);
        }
      });
      getBranchs().then((res) => {
        if (res.success) {
          res.result.forEach((itm) => (itm.value = itm.code));
          this.customDataList["recommendUnitId"] = res.result;
          this.customDataList["concernUnitId"] = res.result;
          this.branchList = res.result;
        }
      });
      getDuesList({ memberCategory: 1 }).then(res => {
        if (res.success) {
          res.result.forEach(itm => {
            itm.value = itm.memberType;
            itm.name = itm.dueName;
          });
          this.duesList = res.result;
          this.customDataList["memberType"] = res.result;
        } else {
          Toast.fail(res.message);
        }
      });
      if (!this.member.memberType) {
        this.member.memberType = 1;
      }

      if (!this.member.gender) {
        this.member.gender = 1;
      }
      if (this.member.memberStatus == 3 ||
        this.member.memberStatus == 13) {
        this.disabled = true
      } else {
        if (
          this.member.memberStatus == null ||
          this.member.memberStatus == 15 ||
          this.member.memberStatus == 16 ||
          this.member.memberStatus == 14 ||
          this.member.memberStatus == 4
        ) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
      this.getDictionaryList();
      this.getMemberTypeList();
      this.getZhiChengList();
      //this.getBranchsList();
      this.getCityList();
    },
  };
</script>

<style lang="less" scoped>
  .buttonBox {
    padding: 20px 10px;
    display: flex;

    button {
      margin: 0 10px
    }
  }

  .base-item {
    margin-top: 10px;
  }

  .nextBtn {
    margin-top: 35px;
    height: 45px !important;
    line-height: 45px;
  }

  .base-box>p {
    font-size: 13px;
    color: #999;
    margin: 20px 0 8px 0;
    margin-left: 20px;
  }

  .fontBox {
    font-size: 14px;
    padding: 0 18px 0;
    //   border-top: #f3f6fb solid 10px;
    color: #323233;
    background: #fff;
  }

  .fontBox thead {
    background: #f2f2f2;
  }

  .fontBox table td {
    font-size: 15px;
    margin: 0;
    color: #000;
    padding: 10px 0;
  }

  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 1;
    border-spacing: 0;
  }

  table td {
    word-break: break-all;
    word-wrap: break-word;
    border: 1px solid #dfdfdf;
  }
</style>
